import { PostHogProvider as ReactPostHogProvider } from '@posthog/react';
import posthog from 'posthog-js';
import type { ReactNode } from 'react';

const posthogKey =
  (import.meta.env.VITE_POSTHOG_KEY as string | undefined) ||
  (import.meta.env.VITE_POSTHOG_PROJECT_TOKEN as string | undefined);
const posthogHost =
  (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ||
  'https://us.i.posthog.com';

const isPostHogEnabled = Boolean(posthogKey);
const isPostHogLoaded = Boolean((posthog as { __loaded?: boolean }).__loaded);

if (isPostHogEnabled && !isPostHogLoaded) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    defaults: '2026-05-30',
    capture_pageview: 'history_change',
    capture_pageleave: true,
  });
}

export function PostHogProvider({ children }: { children: ReactNode }) {
  if (!isPostHogEnabled) {
    return <>{children}</>;
  }

  return (
    <ReactPostHogProvider client={posthog}>{children}</ReactPostHogProvider>
  );
}
